// import hooks
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

// import components
import { Container, Row, Col } from "react-bootstrap";
import RoutPath from "../RoutPath";
import Avatar from "./Avatar";
import AccountList from "./AccountList";
import WishItem from "./WishItem";

// import assets
import "../../assets/css/account.css";
import avatar from "../../assets/img/client1.png";
import { emptyWishlistHeart } from "../../utils/cards-svgs";

// import data

const WishList = ({ name, items }) => {
    // const [name, setName] = useState("mido");

    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();
    return (
        <section className="ocean-section wishlist-section">
            <Container>
                <Row>
                    <RoutPath />
                </Row>
                <Row>
                    {windowWidth >= 992 && (
                        <Col lg={4}>
                            <Avatar
                                avatar={avatar}
                                name={name}
                                points={120}
                                lgClass="lg-side-account-list"
                            />
                            <AccountList />
                        </Col>
                    )}
                    <Col lg={8}>
                        {items ? (
                            <>
                                <h1 className="ocean-h1">
                                    {t("account.list.wish-list")}
                                </h1>
                                {items.map((i) => (
                                    <WishItem item={i} />
                                ))}
                            </>
                        ) : (
                            <>
                                <img src={emptyWishlistHeart} alt="heart" />
                                <h1 className="ocean-lg-h">
                                    {t("account.empty-wishlist")}
                                </h1>
                                <p className="ocean-p-grey">
                                    {t("account.empty-wishlist-txt")}
                                </p>
                                <button className="ocean-btn">
                                    {t("cart.keep-shopping")}
                                </button>
                            </>
                        )}
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default WishList;
